import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  DownloadDashboardResultsRequest,
  DownloadDashboardResultsResponse,
  RetrieveDashboardDetailRequest,
  RetrieveDashboardDetailResponse,
  RetrieveDashboardStructureRequest,
  RetrieveDashboardStructureResponse
} from './tracked-session-dashboard.types';

import {
  requestDownloadDashboardResults,
  requestRetrieveDashboardDetail,
  requestRetrieveDashboardStructure
} from './tracked-session-dashboard.actions';

export const useTrackedSessionDashboardApi = () => {
  const dispatch = useDispatch();

  const retrieveDashboardDetail = useCallback(
    (
      requestData: RetrieveDashboardDetailRequest,
      onSuccess?: (data: RetrieveDashboardDetailResponse['data']) => void,
      onError?: () => void
    ) => {
      dispatch(requestRetrieveDashboardDetail({ requestData, onSuccess, onError }));
    },
    [dispatch]
  );

  const retrieveDashboardStructure = useCallback(
    (
      requestData: RetrieveDashboardStructureRequest,
      onSuccess?: (data: RetrieveDashboardStructureResponse['data']) => void
    ) => {
      dispatch(requestRetrieveDashboardStructure({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const downloadDashboardResults = useCallback(
    (
      requestData: DownloadDashboardResultsRequest,
      onSuccess?: (data: DownloadDashboardResultsResponse['data']) => void
    ) => {
      dispatch(requestDownloadDashboardResults({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { retrieveDashboardDetail, retrieveDashboardStructure, downloadDashboardResults };
};
